import { ObservableArray, View } from "binder"
import { MediaTypeSelector, NoMediaTemplateViewModel, TemplateListViewModel, TemplateViewModel } from "./templateList-viewModel"

export class TemplateListView extends View<TemplateListViewModel>{
    GetViewUniqueId(): string {
        return "V-E987F7E0-1C62-4EC9-96FC-2FBF32F02A63"
    }
    loadHtml(): string {
        let element = require('./templateList.html').default;
        let style = require('./templateList.less');
        return element;
    }
    constructor() {
       super();
    }

    public set templates(v: ObservableArray<TemplateViewModel>) { this._templates = v; } public get templates(): ObservableArray<TemplateViewModel> { return this._templates;} private _templates: ObservableArray<TemplateViewModel>;
    public set selectedTemplate(v: TemplateViewModel) { this._selectedTemplate = v; } public get selectedTemplate(): TemplateViewModel { return this._selectedTemplate;} private _selectedTemplate: TemplateViewModel;
    public set isMain(v: boolean) { this._isMain = v; } public get isMain(): boolean { return this._isMain;} private _isMain: boolean;
    public set isDetail(v: boolean) { this._isDetail = v; } public get isDetail(): boolean { return this._isDetail;} private _isDetail: boolean;
    public set noMediaTemplates(v: ObservableArray<NoMediaTemplateViewModel>) { this._noMediaTemplates = v; } public get noMediaTemplates(): ObservableArray<NoMediaTemplateViewModel> { return this._noMediaTemplates;} private _noMediaTemplates: ObservableArray<NoMediaTemplateViewModel>;
    public set selectedNoMediaTemplate(v: NoMediaTemplateViewModel) { this._selectedNoMediaTemplate = v; } public get selectedNoMediaTemplate(): NoMediaTemplateViewModel { return this._selectedNoMediaTemplate;} private _selectedNoMediaTemplate: NoMediaTemplateViewModel;
    public set mediaTypeSelector(v: MediaTypeSelector) { this._mediaTypeSelector = v; } public get mediaTypeSelector(): MediaTypeSelector { return this._mediaTypeSelector;} private _mediaTypeSelector: MediaTypeSelector;

    createNew(){
        this.dataContext.createNew();
    }
    edit(){
        this.dataContext.edit();
    }
    makeMain(){
        this.dataContext.makeMain();
    }
    makeDetail(){
        this.dataContext.makeDetail();
    }
}
